import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState } from 'react';
import { getErrorMessage, shippingAddressValidation } from '../../../../utils/api';
function useAddressValidation() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    addressIsValid = _useState2[0],
    setAddressIsValid = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    addressSuggestions = _useState4[0],
    setAddressSuggestions = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isValidatingAddress = _useState6[0],
    setIsValidatingAddress = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    validateAddressError = _useState8[0],
    setValidateAddressError = _useState8[1];
  function resetValidation() {
    var isValidating = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    setAddressIsValid(true);
    setAddressSuggestions([]);
    setIsValidatingAddress(isValidating);
    setValidateAddressError(null);
  }
  function validateAddress(_x, _x2) {
    return _validateAddress.apply(this, arguments);
  }
  function _validateAddress() {
    _validateAddress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(captchaToken, addressData) {
      var validationResults, suggestions, errorMessage, _yield$shippingAddres;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            resetValidation();
            validationResults = {
              is_valid: false
            };
            suggestions = [];
            errorMessage = null;
            _context.prev = 4;
            _context.next = 7;
            return shippingAddressValidation(captchaToken, addressData);
          case 7:
            _yield$shippingAddres = _context.sent;
            validationResults = _yield$shippingAddres.validation_results;
            suggestions = _yield$shippingAddres.suggestions;
            _context.next = 16;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](4);
            errorMessage = getErrorMessage(_context.t0, 'Error validating address');
            setValidateAddressError(errorMessage);
          case 16:
            _context.prev = 16;
            setIsValidatingAddress(false);
            return _context.finish(16);
          case 19:
            setAddressIsValid(validationResults.is_valid);
            if (suggestions.length > 0) {
              setAddressSuggestions(suggestions);
            }
            setIsValidatingAddress(false);
            return _context.abrupt("return", {
              isValid: validationResults.is_valid,
              suggestions: suggestions,
              errorMessage: errorMessage
            });
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 12, 16, 19]]);
    }));
    return _validateAddress.apply(this, arguments);
  }
  return {
    addressIsValid: addressIsValid,
    addressSuggestions: addressSuggestions,
    isValidatingAddress: isValidatingAddress,
    validateAddressError: validateAddressError,
    validateAddress: validateAddress,
    resetValidation: resetValidation
  };
}
export default useAddressValidation;